import React, { useMemo, useState } from 'react'

import {
  AdditionalInsurance,
  PreCheckedProviders,
  ProviderPLA,
  RequestForm,
  RequestTypeOptions,
} from 'components/inbox'
import { hasHipaaAccess } from 'utils/hipaa'
import { formTitles } from 'utils/memberComm/formTitles'

const {
  ADDITIONAL_INSURANCE,
  BENEFIT_AMOUNTS,
  COVERAGE,
  EXPENSE_QUESTION,
  IMPROVE_SEARCH_RESULTS,
  INVOICE,
  OTHER,
  PHARMACY_PLA,
  PRE_CHECKED_PROVIDERS,
  PROVIDER_PLA,
  REQUEST_FORM,
  REQUEST_TYPES,
} = formTitles

export const RequestFlows = ({
  requestType,
  setPoptartHistory,
  setOpen,
  setShouldAlert,
  members,
  workingExpense,
  history = [],
}) => {
  const { title } = requestType
  const [suggestedMember, setSuggestedMember] = useState({})

  // MEMBER OPTIONS: Map members to options for dropdown component
  // filter expense options based on the selected memberUuid && HIPAA filter
  const filteredMembers = members.filter(member =>
    hasHipaaAccess('PHI', member.uuid),
  )
  const memberOptions = useMemo(() => {
    return filteredMembers.map(member => {
      if (member.uuid === workingExpense.memberUuid) {
        setSuggestedMember({
          label: `${member.firstName} ${member.lastName}`,
          value: member.uuid,
        })
      }
      return {
        label: `${member.firstName} ${member.lastName}`,
        value: member.uuid,
      }
    })
  }, [members, workingExpense.memberUuid])

  // TODO: change request flows to use ids instead of titles. Our PLA forms are getting
  // more complex and we need flows with multiple steps that reuse titles.

  // when clicking through the poptart, the history is saved as the title of the request
  // the last item in the history array is the current step you are on and rendered here
  switch (history[history.length - 1]) {
    case BENEFIT_AMOUNTS:
    case EXPENSE_QUESTION:
    case INVOICE:
    case COVERAGE:
    case IMPROVE_SEARCH_RESULTS:
    case OTHER:
    case PHARMACY_PLA:
    case REQUEST_FORM:
      // passing the workingExpense, memberOptions, and suggestedMember to the RequestForm
      // as props, determine the suggested expense within the form
      return (
        <RequestForm
          requestTitle={title}
          setOpen={setOpen}
          setShouldAlert={setShouldAlert}
          testId="info_requestForm"
          workingExpense={workingExpense}
          members={members}
          memberOptions={memberOptions}
          suggestedMember={suggestedMember}
        />
      )
    // The following are the paths for the Provider PLA forms
    case PROVIDER_PLA:
      return (
        <ProviderPLA
          setPoptartHistory={setPoptartHistory}
          testId="info_providerPLA"
        />
      )
    case ADDITIONAL_INSURANCE:
      return <AdditionalInsurance testId="info_additionalInsurance" />
    case PRE_CHECKED_PROVIDERS:
      return (
        <PreCheckedProviders
          testId="info_preCheckedProviders"
          setPoptartHistory={setPoptartHistory}
        />
      )
    case REQUEST_TYPES:
    default:
      return <RequestTypeOptions testId="info_requestTypeOptions" />
  }
}
